// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__dwPOs","innerContainer":"Sidebar_innerContainer__8yGCj","title":"Sidebar_title__F9LC7","close":"Sidebar_close__tFCGk"};